import { render, staticRenderFns } from "./UpcomingAssessment.vue?vue&type=template&id=70de0004&scoped=true&lang=pug"
import script from "./UpcomingAssessment.vue?vue&type=script&lang=js"
export * from "./UpcomingAssessment.vue?vue&type=script&lang=js"
import style0 from "./UpcomingAssessment.vue?vue&type=style&index=0&id=70de0004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70de0004",
  null
  
)

export default component.exports